import multigenesysLogo from 'assets/multigenesys/mgs-logo.png'
import multigenesysLogoOnDark from 'assets/multigenesys/MultiGenesys-removebg-preview-1.png'
import multigenesysLogoIcon from 'assets/multigenesys/mgs-ico.png'

import {
  generateColors,
  generateDarkTheme,
  generateTheme
} from '../generateTheme'

import type { TenantConfig, TenantSeedTheme } from '../types'

// Multigenesys branding configuration.
const seed: TenantSeedTheme = {
  primary: '221 83% 53%',
  secondary: '217 91% 60%',
  emailPrimaryHex: '#2563EB',
  emailSecondaryHex: '#3B82F6'
}

const multigenesysConfig: TenantConfig = {
  id: 'multigenesys',

  name: 'Multigenesys',

  tagline: 'Empowering Digital Innovation',

  logo: multigenesysLogo,

  logoTransparent: multigenesysLogoOnDark,

  logoIcon: multigenesysLogoIcon,

  authBrandBackground: '#2563EB',

  // MGS wordmark is visually smaller than Twin Peak's at the same height —
  // bump the auth top-left logo to match the form-side logo (5rem).
  authHomeLogoHeight: '5rem',

  favicon: multigenesysLogoIcon,

  websiteUrl: 'https://multigenesys.com',

  supportEmail: 'contact@multigenesys.com',

  supportPhone: '+91 20 0000 0000',

  theme: generateTheme(seed),

  darkTheme: generateDarkTheme(seed),

  // generateColors derives the app's TEXT palette from its first argument, so
  // it needs a near-black ink (Twin Peak passes its #0E1A2B navy, ~11%
  // lightness) — NOT the vivid brand blue, which would turn body text bright
  // blue and wash the tinted surfaces out to white. #0F172A is the same-hue
  // dark ink (hue 222, 11% lightness); the vivid blue stays in theme/buttons.
  colors: generateColors('#0F172A', '#3B82F6'),

  // Brand blue as the interactive primary; hover one Tailwind step darker.
  buttonPrimaryHex: '#2563EB',

  buttonPrimaryHoverHex: '#1D4ED8',

  storagePrefix: 'multigenesys',

  copyrightHolder: 'Multigenesys'
}

export default multigenesysConfig